import { useMemo } from "react";
import * as THREE from "three";

// Tekstur teks dari canvas (papan nama, logo) — dipasang ke plane agar menempel di dinding/tiang secara 3D, bukan HTML melayang.
export function useTeksTekstur({ baris, w = 512, h = 256, bg = "#ffffff", warna = "#0000CD", ukuran = 60, radius = 48, sub, subWarna = "#6b6b6b", garis }) {
  return useMemo(() => {
    const c = document.createElement("canvas");
    c.width = w; c.height = h;
    const g = c.getContext("2d");
    g.beginPath(); g.roundRect(0, 0, w, h, radius); g.fillStyle = bg; g.fill();
    if (garis) { g.lineWidth = 10; g.strokeStyle = garis; g.beginPath(); g.roundRect(5, 5, w - 10, h - 10, radius - 4); g.stroke(); }
    g.textAlign = "center"; g.textBaseline = "middle"; g.fillStyle = warna;
    g.font = `800 ${ukuran}px 'Plus Jakarta Sans', system-ui, sans-serif`;
    const y0 = sub ? h / 2 - ukuran * 0.35 : h / 2;
    baris.forEach((t, i) => g.fillText(t, w / 2, y0 + (i - (baris.length - 1) / 2) * ukuran * 1.15));
    if (sub) { g.fillStyle = subWarna; g.font = `600 ${ukuran * 0.42}px 'Plus Jakarta Sans', system-ui, sans-serif`; g.fillText(sub, w / 2, y0 + (baris.length - 1) / 2 * ukuran * 1.15 + ukuran * 0.95); }
    const tx = new THREE.CanvasTexture(c);
    tx.anisotropy = 8; tx.colorSpace = THREE.SRGBColorSpace;
    return tx;
  }, [baris.join("|"), w, h, bg, warna, ukuran, radius, sub, subWarna, garis]); // eslint-disable-line
}

export function PapanTeks({ tekstur, lebar, tinggi, ...rest }) {
  return <mesh {...rest}><planeGeometry args={[lebar, tinggi]} /><meshStandardMaterial map={tekstur} transparent roughness={.6} side={THREE.DoubleSide} /></mesh>;
}
